'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var VixButton = _interopDefault(require('../button'));
var VixButtonGroup = _interopDefault(require('../button-group'));
var utils = require('../utils');

var modal = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('transition', {
      attrs: {
        "name": "modal"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.show,
        expression: "show"
      }],
      class: 'modal ' + (_vm.config.className || '')
    }, [_c('div', {
      class: ['modal-box', {
        'modal-box-large': _vm.config.large
      }],
      on: {
        "touchmove": function touchmove($event) {
          _vm.config.preventScroll ? $event.preventDefault() : '';
        }
      }
    }, [_vm.config.closeButton ? _c('i', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "icon-error modal-close",
      on: {
        "click": _vm.onHide
      }
    }) : _vm._e(), _vm._v(" "), _vm.config.title ? _c('div', {
      class: ['modal-title', {
        'modal-title-underline': _vm.config.titleUnderline
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.config.title)
      }
    }) : _vm._e(), _vm._v(" "), _vm.config.title && _vm.config.content && _vm.isPureText(_vm.config.content) && !_vm.config.hint ? _c('div', {
      staticClass: "modal-body"
    }, [_c('div', {
      staticClass: "modal-body-inner-text",
      domProps: {
        "innerHTML": _vm._s(_vm.config.content)
      }
    })]) : _vm.config.content ? _c('div', {
      staticClass: "modal-body",
      class: {
        'modal-body-align-left': _vm.config.title
      }
    }, [_c('div', {
      staticClass: "modal-body-inner",
      domProps: {
        "innerHTML": _vm._s(_vm.config.content + (_vm.config.hint ? '<span style=color:#999>（' + _vm.config.hint + '）</span>' : ''))
      }
    })]) : _c('div', {
      staticClass: "modal-body"
    }, [_c('div', {
      staticClass: "modal-body-inner"
    }, [_vm._t("default")], 2)]), _vm._v(" "), _vm.button[1] ? _c('vix-button-group', [_c('vix-button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "btn-minor",
      attrs: {
        "text": _vm.button[0].text
      },
      on: {
        "click": _vm.button[0].onClick
      }
    }), _vm._v(" "), _c('vix-button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "btn-main",
      attrs: {
        "text": _vm.button[1].text
      },
      on: {
        "click": _vm.button[1].onClick
      }
    })], 1) : _vm.button[0] ? _c('vix-button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "btn-main",
      attrs: {
        "text": _vm.button[0].text
      },
      on: {
        "click": _vm.button[0].onClick
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "modal-mask",
      on: {
        "touchmove": function touchmove($event) {
          $event.preventDefault();
        }
      }
    }), _vm._v(" "), _vm.config.outerContent ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.config.outerContent)
      }
    }) : _vm._e()])]);
  },
  staticRenderFns: [],
  name: 'modal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onHide: Function
  },
  computed: {
    button: function button() {
      return [].concat(this.config.button);
    }
  },
  components: {
    VixButton: VixButton,
    VixButtonGroup: VixButtonGroup
  },
  methods: {
    isPureText: function isPureText(text) {
      return !/<.+>/.test(text);
    }
  }
});

exports.default = modal;
